import { gql } from '@apollo/client';
import useQuery from 'api/hooks/useQuery';
import permissions from 'api/Apollo/permissions';
import tag from 'api/tags/tag';

export const PIPELINE_TAGS_QUERY = 'PipelineTags';

export const GET_PIPELINE_TAGS = gql`
  query ${PIPELINE_TAGS_QUERY}($pipelineId: uuid!) {
    pipeline_tags(where: { pipelineId: { _eq: $pipelineId } }, order_by: { created_at: asc }) {
      id
      tag {
        ...tag
      }
    }
  }
  ${tag}
`;

export default function useQueryPipelineTags({ pipelineId, ...options }) {
  const { data, loading, refetch, ...rest } = useQuery(GET_PIPELINE_TAGS, {
    variables: { pipelineId },
    context: { permission: permissions.readTags },
    ...options,
  });

  return {
    data: data?.pipeline_tags ?? [],
    loading,
    refetch,
    ...rest,
  };
}
